import { render } from "./FullScreenButton.vue?vue&type=template&id=01120854&scoped=true"
import script from "./FullScreenButton.vue?vue&type=script&lang=js"
export * from "./FullScreenButton.vue?vue&type=script&lang=js"

import "./FullScreenButton.vue?vue&type=style&index=0&id=01120854&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01120854"]])

export default __exports__